// Valor de las colectas: se muestra solo con el flag en 'true'. En prod queda
// apagado hasta que producto lo encienda para todos a la vez.
export const collectionAmountsEnabled =
  process.env.REACT_APP_COLLECTION_AMOUNTS === 'true';

export default { collectionAmountsEnabled };
